import React from 'react';
import clsx from 'clsx';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { states } from '@/constants/lifecycle';
import { workspaceFormHealthSources, workspaceForms } from '../constants';
import WorkspaceRequestWizard from './WorkspaceRequestWizard';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const WorkspacePanelContainer = ({
  className,
  code,
  compact,
  url,
}) => {
  const state = Selectors.useWorkspacePanelContainer({ code });
  Fetch.useWorkspaceFormHealthCheck({
    code: workspaceForms.REQUEST,
    source: workspaceFormHealthSources.WORKSPACE,
  }, state.healthCheckReadStatus);
  Fetch.useNewWorkspaceRequest({ code, form: state.form }, state.readStatus);

  return (
    <PanelContainer
      canAccess={state.canCreate}
      entity="workspace"
      exists={state.exists}
      isDirty={state.isDirty}
      readErrors={state.readErrors}
      readStatus={state.healthCheckReadStatus === states.NONE
        ? [states.PENDING]
        : [state.readStatus, state.healthCheckReadStatus]}
      url={url}
    >
      <div className={clsx(className, 'panel-wizard')}>
        <WorkspaceRequestWizard code={code} compact={compact} hideSteps />
      </div>
    </PanelContainer>
  );
};

export default WorkspacePanelContainer;
